<template>
  <div>
    <div class="stepper-wrapper">
      <!-- 準備中 -->
      <div
        class="stepper-item"
        :class="stepCount | stepperStatus('ready')"
      >
        <div
          v-if="stepCount === 0"
          class="step-counter"
        >
          <v-icon>
            mdi-truck
          </v-icon>
        </div>
        <div
          v-if="stepCount === 0"
          class="step-name"
        >
        </div>
      </div>
      <!-- /準備中 -->

      <!-- 回収中 -->
      <div
        v-if="false"
        class="stepper-item"
        :class="stepCount | stepperStatus('collect')"
      >
        <div
          v-if="stepCount === 1"
          class="step-counter"
        >
          <v-icon>
            mdi-truck
          </v-icon>
        </div>
        <div
          v-if="stepCount === 1"
          class="step-name"
        >
          回収中
        </div>
      </div>
      <!-- /回収中 -->

      <!-- 運搬中 -->
      <div
        class="stepper-item"
        :class="stepCount | stepperStatus('transport')"
      >
        <div
          v-if="stepCount === 2"
          class="step-counter"
        >
          <v-icon>
            mdi-truck
          </v-icon>
        </div>
        <div
          v-if="stepCount === 2"
          class="step-name"
        >
          運搬中
        </div>
      </div>
      <!-- /運搬中 -->

      <!-- 作業完了 -->
      <div
        class="stepper-item"
        :class="stepCount | stepperStatus('done')"
      >
        <div
          v-if="stepCount === 3"
          class="step-counter"
        >
          <v-icon>
            mdi-thumb-up
          </v-icon>
        </div>
        <div
          v-if="stepCount === 3"
          class="step-name"
        >
          作業完了
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepProgressSlider',
  components: {},
  filters: {
    /**
     * ステッパーのカラーを設定
     * @param step { Number } ステップ数
     * @param type { String } 対象となるステップ識別子 ready, transport, done
     * @return {null}
     */
    stepperStatus: function(step, type) {
      let status = ''

      switch (type) {
        case 'ready':
          if (step === 0) {
            status = 'not_work'
          } else if ( step === 3) {
            status = 'finished'
          } else if (step > 0) {
            status = 'completed'
          }
          break
        case 'collect':
          if (step === 1) {
            status = 'active'
          } else if ( step === 3) {
            status = 'finished'
          } else if (step > 1) {
            status = 'completed'
          }
          break
        case 'transport':
          if (step === 2) {
            status = 'active'
          } else if ( step === 3) {
            status = 'finished'
          } else if (step > 2) {
            status = 'completed'
          }
          break
        case 'done':
          if (step === 3) {
            status = 'finished'
          } else if (step > 3) {
            status = 'completed'
          }
          break
      }


      // ready, collect, transport, done

      // 'completed or active'

      return status
    }
  },
  mixins: [],
  props: {
    stepCount: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.stepper-wrapper {
  margin-top: auto;
  display: flex;
  justify-content: space-between;

  & .stepper-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;

    &:first-child::before {
      content: none;
    }
    &:last-child::after {
      content: none;
    }

    @media (max-width: 768px) {
      font-size: 12px;
    }

    &.active {
      font-weight: bold;
      & .step-counter {
        border: 2px solid #0D74BA;
        & i {
          color: #0D74BA !important;
        }
      }
      & .step-name {
        color: #0D74BA !important;
      }
    }
    &.not_work {
      & .step-counter {
        border: 2px solid #757575;
      }
    }

    &.finished {
      & .step-counter {
        border: 2px solid #c9624a;
        & i {
          color: #c9624a !important;
        }
      }
      & .step-name {
        color: #c9624a !important;
      }
    }

    &::before {
      position: absolute;
      content: "";
      border-bottom: 5px solid #ccc;
      width: 100%;
      top: 20px;
      left: -50%;
      z-index: 1;
    }
    &::after {
      position: absolute;
      content: "";
      border-bottom: 5px solid #ccc;
      width: 100%;
      top: 20px;
      left: 50%;
      z-index: 1;
    }

    // アイコンの囲い
    & .step-counter {
      background-color: #fff;
      position: relative;
      z-index: 3;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      //background: #ccc;
      margin-bottom: 6px;
    }

    & .step-name {
      font-weight: normal;
      font-size: 90%;
    }

  }

}

.stepper-item.completed::after {
  position: absolute;
  content: "";
  border-bottom: 5px solid #56A8CC;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 2;
}

.stepper-item.finished::after {
  position: absolute;
  content: "";
  border-bottom: 5px solid #DCAA4E;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 2;
}

</style>
